import { render, staticRenderFns } from "./TemplateDashboard.vue?vue&type=template&id=1139694e&scoped=true&"
import script from "./TemplateDashboard.ts?vue&type=script&lang=ts&"
export * from "./TemplateDashboard.ts?vue&type=script&lang=ts&"
import style0 from "./TemplateDashboard.scss?vue&type=style&index=0&id=1139694e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1139694e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
